var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.894 20.56L16.273 3.933a2.626 2.626 0 00-4.545 0L2.107 20.56a2.625 2.625 0 002.271 3.94h19.245a2.625 2.625 0 002.271-3.94zm-12.77-9.185a.875.875 0 111.75 0v4.375a.875.875 0 11-1.75 0v-4.375zM14 21a1.313 1.313 0 110-2.625A1.313 1.313 0 0114 21z",
    fill: "#EB0045"
  })));
}
export default SvgWarning;